// Layout.tsx
import React from 'react'
import { motion } from 'framer-motion'
import ParticleBackground from './ParticleBackground'
import { useTheme, themeStyles } from '../context/ThemeContext'

interface LayoutProps {
  children: React.ReactNode
}

const Layout: React.FC<LayoutProps> = ({ children }) => {
  const { theme } = useTheme();
  const currentTheme = themeStyles[theme];
  
  return (
    <motion.div
      className={`min-h-screen w-full bg-gradient-to-b ${currentTheme.background} ${currentTheme.text} relative`}
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.3 }}
    >
      {/* Optionally remove or keep */}
      <ParticleBackground />
      {/* Page Content */}
      <div className="relative z-10 w-full min-h-screen">{children}</div>
    </motion.div>
  )
}

export default Layout
